import type { MappingSuggestionsParams } from './suggestion-types';
import type {
  ConflictListingsParams,
  DuplicateListingsParams,
  MappableListingsParams,
  MappingItemsParams,
} from './types';

export const catalogMappingKeys = {
  all: ['catalog-mapping'] as const,
  mappableLists: () => [...catalogMappingKeys.all, 'mappable'] as const,
  mappable: (params: MappableListingsParams) =>
    [...catalogMappingKeys.mappableLists(), params] as const,
  unmappedCount: () =>
    [...catalogMappingKeys.mappableLists(), 'unmapped-count'] as const,
  /*
   * The Mapping tab's queues and its header counts sit inside mappableLists():
   * every write that refreshes the mappable listings (map, exclude, create
   * item) refreshes them too, and so does a write of the tab's own.
   */
  suggestions: (params: MappingSuggestionsParams) =>
    [...catalogMappingKeys.mappableLists(), 'suggestions', params] as const,
  suggestionCounts: () =>
    [...catalogMappingKeys.mappableLists(), 'suggestion-counts'] as const,
  mappingItems: (params: MappingItemsParams) =>
    [...catalogMappingKeys.all, 'mapping-items', params] as const,
  duplicateLists: () => [...catalogMappingKeys.all, 'duplicates'] as const,
  duplicates: (params: DuplicateListingsParams) =>
    [...catalogMappingKeys.duplicateLists(), params] as const,
  duplicatePages: (params: DuplicateListingsParams) =>
    [...catalogMappingKeys.all, 'duplicates-page', params] as const,
  conflictLists: () => [...catalogMappingKeys.all, 'conflicts'] as const,
  conflicts: (params: ConflictListingsParams) =>
    [...catalogMappingKeys.conflictLists(), params] as const,
  conflictPages: (params: ConflictListingsParams) =>
    [...catalogMappingKeys.all, 'conflicts-page', params] as const,
};
